import HelperCookie from "./HelperCookie";
import HelperGoogleAnalytics4 from "@helpers/HelperGoogleAnalytics4";
import HelperGoogleAnalytics from "@helpers/HelperGoogleAnalytics";

/**
 * Извлича TLD частта от домейн.
 * Пример: "example.com" -> "com", "sub.domain.bg" -> "domain.bg"
 */
export function extractDomainTLD(domainNameFull) {
	if (!domainNameFull) return "";
	const normalized = domainNameFull.toLowerCase().trim();
	const parts = normalized.split(".");
	if (parts.length < 2) return "";

	const [, ...rest] = parts;
	return rest.join(".");
}

/**
 * Оценка на парола.
 * Връща числова стойност (колкото по-висока, толкова по-силна).
 */
export function scorePassword(pass) {
	if (!pass) return 0;

	let hasConsecutive = false;
	const sequence =
	  "01234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

	// Търсим поредици от 3 последователни символа (напред/назад)
	for (let i = 0; i <= sequence.length - 3; i++) {
		const slice = sequence.slice(i, i + 3);
		const reversed = slice.split("").reverse().join("");

		if (pass.includes(slice) || pass.includes(reversed)) {
			hasConsecutive = true;
			break;
		}
	}

	let score = 0;

	// Точки за уникални символи
	const letters = {};
	for (const ch of pass) {
		letters[ch] = (letters[ch] || 0) + 1;
		score += 5 / letters[ch];
	}

	const variations = {
		digits: /\d/.test(pass),
		lower: /[a-z]/.test(pass),
		upper: /[A-Z]/.test(pass),
		nonWords: /\W/.test(pass),
	};

	const variationCount = Object.values(variations).filter(Boolean).length;
	score += (variationCount - 1) * 7;

	if (hasConsecutive) {
		score -= 10;
	}

	return Math.round(score);
}

/**
 * Съкращава домейн до дадена максимална дължина,
 * запазвайки TLD и малко от края.
 */
export function truncateDomainName(domainNameFull, domainTld, maxLen) {
	if (!domainNameFull || typeof domainNameFull !== "string") return "";
	if (domainNameFull.length <= maxLen) return domainNameFull;

	const lastPartLen = domainTld.length + 5;
	const dotsCount = 1;

	const lastPart = domainNameFull.substring(
	  domainNameFull.length - lastPartLen
	);
	const firstPart = domainNameFull.substring(
	  0,
	  maxLen - lastPartLen - dotsCount
	);

	return `${firstPart}…${lastPart}`;
}

export function TruncateByChars(text, maxChars) {
	if (!text) return '';
	return text.length > maxChars
	  ? text.slice(0, maxChars).trim() + '…'
	  : text;
}

/**
 * Проверява дали елементът е в viewport.
 * Ако partiallyVisible = true → стига да е частично видим.
 */
export function isInViewport(element, partiallyVisible = false) {
	if (typeof window === "undefined" || !element) return false;

	const rect = element.getBoundingClientRect();
	const elemTop = rect.top;
	const elemBottom = rect.bottom;

	if (partiallyVisible) {
		return elemTop < window.innerHeight / 2 && elemBottom >= 0;
	}

	return elemTop >= 0 && elemBottom <= window.innerHeight;
}

/**
 * Създава fingerprint за конкретния браузър.
 * Запазва го като cookie (между поддомейните) и в localStorage.
 */
export function manageFingerPrint() {
	const fpKey = "hfrvllcstor";

	if (typeof window === "undefined" || !window.localStorage) {
		return;
	}

	const ls = window.localStorage.getItem(fpKey);
	const cv = HelperCookie.getCookie(fpKey);

	// Вече е синхронизирано
	if (ls === cv && ls !== "") {
		return;
	}

	let value = ls;

	if (!ls) {
		value = cv;
		if (!value) {
			value =
			  Math.random().toString(36).substring(2, 9) +
			  Math.random().toString(36).substring(2, 9) +
			  Date.now().toString(16);
		}
	}

	if (!ls || !cv) {
		const hostParts = window.location.hostname.split(".");
		const domain =
		  hostParts.length >= 2
			? `${hostParts[hostParts.length - 2]}.${
			  hostParts[hostParts.length - 1]
			}`
			: window.location.hostname;

		window.localStorage.setItem(fpKey, value);
		HelperCookie.setCookie(fpKey, value, 720, domain);
	}
}

/**
 * Транслитерация към латиница.
 */
export function translateToLatin(value) {
	const lt = [];
	lt["а"] = "a";
	lt["б"] = "b";
	lt["в"] = "v";
	lt["г"] = "g";
	lt["д"] = "d";
	lt["е"] = "e";
	lt["ж"] = "zh";
	lt["з"] = "z";
	lt["и"] = "i";
	lt["й"] = "y";
	lt["к"] = "k";
	lt["л"] = "l";
	lt["м"] = "m";
	lt["н"] = "n";
	lt["о"] = "o";
	lt["п"] = "p";
	lt["р"] = "r";
	lt["с"] = "s";
	lt["т"] = "t";
	lt["у"] = "u";
	lt["ф"] = "f";
	lt["х"] = "h";
	lt["ц"] = "ts";
	lt["ч"] = "ch";
	lt["ш"] = "sh";
	lt["щ"] = "sht";
	lt["ъ"] = "a";
	lt["ь"] = "y";
	lt["ю"] = "yu";
	lt["я"] = "ya";
	lt["№"] = "N.";
	lt["\\"] = " ";
	lt["/"] = " ";
	lt["À"] = "A";
	lt["Á"] = "A";
	lt["Â"] = "A";
	lt["Ã"] = "A";
	lt["Ä"] = "A";
	lt["Å"] = "A";
	lt["Æ"] = "AE";
	lt["Ç"] = "C";
	lt["È"] = "E";
	lt["É"] = "E";
	lt["Ê"] = "E";
	lt["Ë"] = "E";
	lt["Ì"] = "I";
	lt["Í"] = "I";
	lt["Î"] = "I";
	lt["Ï"] = "I";
	lt["Ð"] = "D";
	lt["Ñ"] = "N";
	lt["Ò"] = "O";
	lt["Ó"] = "O";
	lt["Ô"] = "O";
	lt["Õ"] = "O";
	lt["Ö"] = "O";
	lt["Ø"] = "O";
	lt["Ù"] = "U";
	lt["Ú"] = "U";
	lt["Û"] = "U";
	lt["Ü"] = "U";
	lt["Ý"] = "Y";
	lt["ß"] = "s";
	lt["à"] = "a";
	lt["á"] = "a";
	lt["â"] = "a";
	lt["ã"] = "a";
	lt["ä"] = "a";
	lt["å"] = "a";
	lt["æ"] = "ae";
	lt["ç"] = "c";
	lt["è"] = "e";
	lt["é"] = "e";
	lt["ê"] = "e";
	lt["ë"] = "e";
	lt["ì"] = "i";
	lt["í"] = "i";
	lt["î"] = "i";
	lt["ï"] = "i";
	lt["ñ"] = "n";
	lt["ò"] = "o";
	lt["ó"] = "o";
	lt["ô"] = "o";
	lt["õ"] = "o";
	lt["ö"] = "o";
	lt["ø"] = "o";
	lt["ù"] = "u";
	lt["ú"] = "u";
	lt["û"] = "u";
	lt["ü"] = "u";
	lt["ý"] = "y";
	lt["ÿ"] = "y";
	lt["Ā"] = "A";
	lt["ā"] = "a";
	lt["Ă"] = "A";
	lt["ă"] = "a";
	lt["Ą"] = "A";
	lt["ą"] = "a";
	lt["Ć"] = "C";
	lt["ć"] = "c";
	lt["Ĉ"] = "C";
	lt["ĉ"] = "c";
	lt["Ċ"] = "C";
	lt["ċ"] = "c";
	lt["Č"] = "C";
	lt["č"] = "c";
	lt["Ď"] = "D";
	lt["ď"] = "d";
	lt["Đ"] = "D";
	lt["đ"] = "d";
	lt["Ē"] = "E";
	lt["ē"] = "e";
	lt["Ĕ"] = "E";
	lt["ĕ"] = "e";
	lt["Ė"] = "E";
	lt["ė"] = "e";
	lt["Ę"] = "E";
	lt["ę"] = "e";
	lt["Ě"] = "E";
	lt["ě"] = "e";
	lt["Ĝ"] = "G";
	lt["ĝ"] = "g";
	lt["Ğ"] = "G";
	lt["ğ"] = "g";
	lt["Ġ"] = "G";
	lt["ġ"] = "g";
	lt["Ģ"] = "G";
	lt["ģ"] = "g";
	lt["Ĥ"] = "H";
	lt["ĥ"] = "h";
	lt["Ħ"] = "H";
	lt["ħ"] = "h";
	lt["Ĩ"] = "I";
	lt["ĩ"] = "i";
	lt["Ī"] = "I";
	lt["ī"] = "i";
	lt["Ĭ"] = "I";
	lt["ĭ"] = "i";
	lt["Į"] = "I";
	lt["į"] = "i";
	lt["İ"] = "I";
	lt["ı"] = "i";
	lt["Ĳ"] = "IJ";
	lt["ĳ"] = "ij";
	lt["Ĵ"] = "J";
	lt["ĵ"] = "j";
	lt["Ķ"] = "K";
	lt["ķ"] = "k";
	lt["Ĺ"] = "L";
	lt["ĺ"] = "l";
	lt["Ļ"] = "L";
	lt["ļ"] = "l";
	lt["Ľ"] = "L";
	lt["ľ"] = "l";
	lt["Ŀ"] = "L";
	lt["ŀ"] = "l";
	lt["Ł"] = "l";
	lt["ł"] = "l";
	lt["Ń"] = "N";
	lt["ń"] = "n";
	lt["Ņ"] = "N";
	lt["ņ"] = "n";
	lt["Ň"] = "N";
	lt["ň"] = "n";
	lt["ŉ"] = "n";
	lt["Ō"] = "O";
	lt["ō"] = "o";
	lt["Ŏ"] = "O";
	lt["ŏ"] = "o";
	lt["Ő"] = "O";
	lt["ő"] = "o";
	lt["Œ"] = "OE";
	lt["œ"] = "oe";
	lt["Ŕ"] = "R";
	lt["ŕ"] = "r";
	lt["Ŗ"] = "R";
	lt["ŗ"] = "r";
	lt["Ř"] = "R";
	lt["ř"] = "r";
	lt["Ś"] = "S";
	lt["ś"] = "s";
	lt["Ŝ"] = "S";
	lt["ŝ"] = "s";
	lt["Ş"] = "S";
	lt["ş"] = "s";
	lt["Š"] = "S";
	lt["š"] = "s";
	lt["Ţ"] = "T";
	lt["ţ"] = "t";
	lt["Ť"] = "T";
	lt["ť"] = "t";
	lt["Ŧ"] = "T";
	lt["ŧ"] = "t";
	lt["Ũ"] = "U";
	lt["ũ"] = "u";
	lt["Ū"] = "U";
	lt["ū"] = "u";
	lt["Ŭ"] = "U";
	lt["ŭ"] = "u";
	lt["Ů"] = "U";
	lt["ů"] = "u";
	lt["Ű"] = "U";
	lt["ű"] = "u";
	lt["Ų"] = "U";
	lt["ų"] = "u";
	lt["Ŵ"] = "W";
	lt["ŵ"] = "w";
	lt["Ŷ"] = "Y";
	lt["ŷ"] = "y";
	lt["Ÿ"] = "Y";
	lt["Ź"] = "Z";
	lt["ź"] = "z";
	lt["Ż"] = "Z";
	lt["ż"] = "z";
	lt["Ž"] = "Z";
	lt["ž"] = "z";
	lt["ſ"] = "s";
	lt["ƒ"] = "f";
	lt["Ơ"] = "O";
	lt["ơ"] = "o";
	lt["Ư"] = "U";
	lt["ư"] = "u";
	lt["Ǎ"] = "A";
	lt["ǎ"] = "a";
	lt["Ǐ"] = "I";
	lt["ǐ"] = "i";
	lt["Ǒ"] = "O";
	lt["ǒ"] = "o";
	lt["Ǔ"] = "U";
	lt["ǔ"] = "u";
	lt["Ǖ"] = "U";
	lt["ǖ"] = "u";
	lt["Ǘ"] = "U";
	lt["ǘ"] = "u";
	lt["Ǚ"] = "U";
	lt["ǚ"] = "u";
	lt["Ǜ"] = "U";
	lt["ǜ"] = "u";
	lt["Ǻ"] = "A";
	lt["ǻ"] = "a";
	lt["Ǽ"] = "AE";
	lt["ǽ"] = "ae";
	lt["Ǿ"] = "O";
	lt["ǿ"] = "o";
	lt["Ѐ"] = "E";
	lt["Ё"] = "E";
	lt["Ђ"] = "Dj";
	lt["Ѓ"] = "G";
	lt["Є"] = "E";
	lt["Ѕ"] = "S";
	lt["І"] = "I";
	lt["Ї"] = "I";
	lt["Ј"] = "J";
	lt["Љ"] = "Ly";
	lt["Њ"] = "Ny";
	lt["Ћ"] = "Che";
	lt["Ќ"] = "Ky";
	lt["Ѝ"] = "Y";
	lt["Ў"] = "U";
	lt["Џ"] = "J";
	lt["А"] = "A";
	lt["Б"] = "B";
	lt["В"] = "V";
	lt["Г"] = "G";
	lt["Д"] = "D";
	lt["Е"] = "E";
	lt["Ж"] = "J";
	lt["З"] = "Z";
	lt["И"] = "I";
	lt["Й"] = "J";
	lt["К"] = "K";
	lt["Л"] = "L";
	lt["М"] = "M";
	lt["Н"] = "N";
	lt["О"] = "O";
	lt["П"] = "P";
	lt["Р"] = "R";
	lt["С"] = "S";
	lt["Т"] = "T";
	lt["У"] = "U";
	lt["Ф"] = "F";
	lt["Х"] = "H";
	lt["Ц"] = "Ts";
	lt["Ч"] = "Ch";
	lt["Ш"] = "Sh";
	lt["Щ"] = "Sht";
	lt["Ъ"] = "A";
	lt["Ы"] = "Y";
	lt["Ь"] = "Y";
	lt["Э"] = "E";
	lt["Ю"] = "Yu";
	lt["Я"] = "Ya";
	lt["а"] = "a";
	lt["б"] = "b";
	lt["в"] = "v";
	lt["г"] = "g";
	lt["д"] = "d";
	lt["е"] = "e";
	lt["ж"] = "j";
	lt["з"] = "z";
	lt["и"] = "i";
	lt["й"] = "y";
	lt["к"] = "k";
	lt["л"] = "l";
	lt["м"] = "m";
	lt["н"] = "n";
	lt["о"] = "o";
	lt["п"] = "p";
	lt["р"] = "r";
	lt["с"] = "s";
	lt["т"] = "t";
	lt["у"] = "u";
	lt["ф"] = "f";
	lt["х"] = "h";
	lt["ц"] = "ts";
	lt["ч"] = "ch";
	lt["ш"] = "sh";
	lt["щ"] = "sht";
	lt["ъ"] = "a";
	lt["ы"] = "y";
	lt["ь"] = "y";
	lt["э"] = "e";
	lt["ю"] = "yu";
	lt["я"] = "ya";
	lt["ѐ"] = "ye";
	lt["ё"] = "yo";
	lt["ђ"] = "g";
	lt["ѓ"] = "g";
	lt["є"] = "ye";
	lt["ѕ"] = "c";
	lt["і"] = "i";
	lt["ї"] = "y";
	lt["ј"] = "j";
	lt["љ"] = "ly";
	lt["њ"] = "ny";
	lt["ћ"] = "che";
	lt["ќ"] = "k";
	lt["ѝ"] = "i";
	lt["ў"] = "u";
	lt["џ"] = "j";
	lt["Ѣ"] = "y";
	lt["ѣ"] = "y";
	lt["Ґ"] = "G";
	lt["ґ"] = "g";
	lt["Ғ"] = "G";
	lt["ғ"] = "g";
	lt["Ҕ"] = "G";
	lt["ҕ"] = "g";
	lt["Җ"] = "J";
	lt["җ"] = "j";
	lt["Ҙ"] = "Z";
	lt["ҙ"] = "z";
	lt["Қ"] = "K";
	lt["қ"] = "k";
	lt["Ң"] = "N";
	lt["ң"] = "n";
	lt["Ҥ"] = "Ng";
	lt["ҥ"] = "ng";
	lt["Ҫ"] = "S";
	lt["ҫ"] = "s";
	lt["Ҭ"] = "T";
	lt["ҭ"] = "t";
	lt["Ү"] = "Y";
	lt["ү"] = "y";
	lt["Ұ"] = "Y";
	lt["ұ"] = "y";
	lt["Ҳ"] = "H";
	lt["ҳ"] = "h";
	lt["Һ"] = "Sh";
	lt["һ"] = "sh";
	lt["Ӏ"] = "I";
	lt["Ӂ"] = "J";
	lt["ӂ"] = "j";
	lt["Ӄ"] = "K";
	lt["ӄ"] = "k";
	lt["Ӈ"] = "N";
	lt["ӈ"] = "n";
	lt["Ӌ"] = "Ch";
	lt["ӌ"] = "ch";
	lt["ӏ"] = "i";
	lt["Ӑ"] = "A";
	lt["ӑ"] = "a";
	lt["Ӓ"] = "A";
	lt["ӓ"] = "a";
	lt["Ӕ"] = "Ae";
	lt["ӕ"] = "ae";
	lt["Ӗ"] = "E";
	lt["ӗ"] = "e";
	lt["Ә"] = "A";
	lt["ә"] = "a";
	lt["Ӛ"] = "A";
	lt["ӛ"] = "a";
	lt["Ӝ"] = "J";
	lt["ӝ"] = "j";
	lt["Ӟ"] = "Z";
	lt["ӟ"] = "z";
	lt["Ӡ"] = "Z";
	lt["ӡ"] = "z";
	lt["Ӣ"] = "I";
	lt["ӣ"] = "i";
	lt["Ӥ"] = "I";
	lt["ӥ"] = "i";
	lt["Ӧ"] = "O";
	lt["ӧ"] = "o";
	lt["Ө"] = "O";
	lt["ө"] = "o";
	lt["Ӫ"] = "O";
	lt["ӫ"] = "o";
	lt["Ӭ"] = "E";
	lt["ӭ"] = "e";
	lt["Ӯ"] = "U";
	lt["ӯ"] = "u";
	lt["Ӱ"] = "U";
	lt["ӱ"] = "u";
	lt["Ӳ"] = "U";
	lt["ӳ"] = "u";
	lt["Ӵ"] = "Ch";
	lt["ӵ"] = "ch";
	lt["Ӷ"] = "G";
	lt["ӷ"] = "g";
	lt["Ӹ"] = "Y";
	lt["ӹ"] = "y";
	lt["-"] = "-";
	lt["~"] = "-";
	lt["­"] = "-";
	lt["֊"] = "-";
	lt["־"] = "-";
	lt["᠆"] = "-";
	lt["‐"] = "-";
	lt["-"] = "-";
	lt["‒"] = "-";
	lt["–"] = "-";
	lt["—"] = "-";
	lt["―"] = "-";
	lt["⁻"] = "-";
	lt["₋"] = "-";
	lt["−"] = "-";
	lt["⸗"] = "-";
	lt["〜"] = "-";
	lt["〰"] = "-";
	lt["゠"] = "-";
	lt["︱"] = "-";
	lt["﹣"] = "-";
	lt["－"] = "-";
	lt["〃"] = "`";
	lt["״"] = "`";
	lt["＂"] = "`";
	lt["ˮ"] = "`";
	lt["ײ"] = "`";
	lt["″"] = "`";
	lt["ʺ"] = "`";
	lt["˝"] = "`";
	lt["‶"] = "`";
	lt["‟"] = "`";
	lt["˶"] = "`";
	lt["”"] = "`";
	lt["“"] = "`";
	lt["0"] = "0";
	lt["1"] = "1";
	lt["2"] = "2";
	lt["3"] = "3";
	lt["4"] = "4";
	lt["5"] = "5";
	lt["6"] = "6";
	lt["7"] = "7";
	lt["8"] = "8";
	lt["9"] = "9";

	let res = "";
	const src = value || "";
	if (src === "") return "";

	for (let i = 0; i < src.length; i++) {
		let l = src.charAt(i);

		if (lt[l] == null) {
			l = l.toLowerCase();
			if (lt[l] == null) {
				res += src.charAt(i);
			} else {
				l = lt[l];
				res += l.toUpperCase();
			}
		} else {
			res += lt[l];
		}
	}

	// eslint-disable-next-line no-control-regex
	res = res.replace(/([^\x00-\xFF])*$/g, "");

	return res;
}

/**
 * Проверка за WebP поддръжка.
 * callback(true|false)
 */
export function canUseWebp(callback) {
	if (typeof window === "undefined") {
		callback(false);
		return;
	}

	const webpImg =
	  "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==";
	const img = new Image();

	img.onload = () => {
		const result = img.width > 0 && img.height > 0;
		callback(result);
	};

	img.onerror = () => {
		callback(false);
	};

	img.src = `data:image/webp;base64,${webpImg}`;
}

/**
 * Проверява дали даден ключ/property съществува в даден обект.
 */
export function hasProperty(object, property) {
	if (object === null || object === undefined) {
		return false;
	}
	return Object.prototype.hasOwnProperty.call(object, property);
}

/**
 * Унифициран foreach за Array и Object.
 *
 * @callback mapThroughObjectAndArrayCallback
 * @param {string|number} index - ключ
 * @param {*} value - стойност
 */

/**
 * @param {(Array|Object)} data
 * @param {mapThroughObjectAndArrayCallback} callback
 * @return {*[]|undefined}
 */
export function foreach(data, callback) {
	if (data == null || typeof callback !== "function") {
		console.error("forEachData: Invalid arguments!");
		return;
	}

	const resultArray = [];

	if (Array.isArray(data)) {
		for (let index = 0; index < data.length; index++) {
			resultArray.push(callback(index, data[index]));
		}
	} else if (typeof data === "object") {
		const entries = Object.entries(data);
		for (let i = 0; i < entries.length; i++) {
			const [key, value] = entries[i];
			resultArray.push(callback(key, value));
		}
	} else {
		console.error("forEachData: Invalid data type!");
		return;
	}

	return resultArray;
}

/**
 * Отваря линк в нов таб, симулирайки клик.
 */
export function goToBlank(url) {
	if (typeof window === "undefined") return;

	const a = window.document.createElement("a");
	a.target = "_blank";
	a.rel = "noopener noreferrer";
	a.href = url;

	const e = window.document.createEvent("MouseEvents");
	e.initMouseEvent(
	  "click",
	  true,
	  true,
	  window,
	  0,
	  0,
	  0,
	  0,
	  0,
	  false,
	  false,
	  false,
	  false,
	  0,
	  null
	);

	a.dispatchEvent(e);
	a.remove();
}

/**
 * Връща последния ден от текущия месец във формат:
 * DD{sep}MM{sep}YYYY
 */
export function getEndOfMonth(returnOnly = '', separator = '') {
	const today = new Date();
	const lastDayOfMonth = new Date(
	  today.getFullYear(),
	  today.getMonth() + 1,
	  0
	);

	const date = lastDayOfMonth.getDate();
	const month = lastDayOfMonth.getMonth() + 1;
	const year = lastDayOfMonth.getFullYear();

	const monthStr = month < 10 ? `0${month}` : `${month}`;

	switch (returnOnly) {
		case 'day':
			return `${date}`;
		case 'month':
			return `${monthStr}`;
		case 'year':
			return `${year}`;
		default:
			return `${date}${separator}${monthStr}${separator}${year}`;
	}
}

/**
 * Връща URL адрес или прави директно редирект към Английска/Българска версия на сайта.
 *
 * @param e event param
 * @returns window.location, string
 */
export function changeLanguage(e) {
	if (e?.preventDefault) {
		e.preventDefault();
	}

	const {protocol, hostname, pathname, search, hash} = window.location;

	const hostNoWww = hostname.replace(/^www\./, '');

	const hasEn = /^en\./.test(hostNoWww);
	const newHostname = hasEn ? hostNoWww.replace(/^en\./, '') : `en.${hostNoWww}`;

	const newUrl = `${protocol}//${newHostname}${pathname}${search}${hash}`;

	if (e?.preventDefault) {
		window.location.replace(newUrl);
	} else {
		return newUrl;
	}
}

/**
 * Съкращава твърде дълго име на клиента
 *
 * @param name customer name
 * @param maxLength max length
 * @param firstNameMaxLength max length of the first name
 * @returns string
 */
export function shortenCustomerName(name, maxLength = 30, firstNameMaxLength = 20) {
	if (!name || typeof name !== 'string') {
		return '';
	}

	const cleanName = name.trim().replace(/\s+/g, ' ');

	// 1. Ако цялото име се събира – връщаме го
	if (cleanName.length <= maxLength) {
		return cleanName;
	}

	// 2. Вземаме първото име
	const [firstName] = cleanName.split(' ');

	// 3. Ако първото име е в лимита – връщаме го
	if (firstName.length <= firstNameMaxLength) {
		return firstName;
	}

	// 4. Ако и то е твърде дълго – режем + ...
	return `${firstName.slice(0, firstNameMaxLength)}...`;
}

/**
 * Връща инициалите на клиента (първа буква от името и първа буква от фамилията)
 *
 * @param name customer name
 * @returns string
 */
export function getCustomerInitials(name) {
	if (!name || typeof name !== 'string') {
		return '';
	}

	const cleanName = name.trim().replace(/\s+/g, ' ');
	const parts = cleanName.split(' ');

	if (parts.length === 0) {
		return '';
	}

	// Вземаме първата буква от първото име
	const firstInitial = parts[0].charAt(0).toUpperCase();

	// Ако има фамилия, вземаме първата буква от нея
	if (parts.length > 1) {
		const lastInitial = parts[parts.length - 1].charAt(0).toUpperCase();
		return `${firstInitial}${lastInitial}`;
	}

	// Ако има само едно име, връщаме само една буква
	return firstInitial;
}

/**
 * Изчислява височините на докнатите елементи
 *
 * @param dockIds id-тата на докнатите елементи
 * @param extra допълнителен offset (напр. за padding)
 * @param multiplier (sum * multiplier) + extra
 * @returns number
 */
export function getDockHeight({
								  dockIds = [], // Example: ['menuHolder', 'tabsNavHolder']
								  extra = 0,
								  multiplier = 1, // #menuHolder + #tabsNavHolder * multiplier (for height calculation and offset)
							  } = {}) {

	if (!Array.isArray(dockIds) || dockIds.length === 0) return 0;

	const sum = dockIds.reduce((acc, id) => {
		const el = document.getElementById(id);
		if (!el) return acc;
		const h = el.getBoundingClientRect()?.height ?? 0;
		return acc + (Number.isFinite(h) ? h : 0);
	}, 0);

	return (sum * multiplier) + extra;
}

/**
 * Скролва страницата до даден елемент, като отчита височините на докнатите елементи (напр. меню, табове) и допълнителен offset.
 *
 * @param target елемента до който да скролне
 * @param options обект с настройки
 * @returns boolean
 */
export function ScrollToTarget(target, {
	behavior = 'smooth',
	dockIds = ['menuHolder', 'tabsNavHolder'],
	extraOffset = 0,
	multiplier = 1,
	align = 'start', // start | center
	clampToTop = true,
	retries = 3 // Important for Android/Safari on first load
} = {}) {

	let el = null;

	if (typeof target === 'string') {
		el = document.getElementById(target);
	} else if (target instanceof Element) {
		el = target;
	}

	if (!el) return false;

	const doScroll = () => {
		const dockOffset = getDockHeight({dockIds, extra: extraOffset, multiplier});

		const rect = el.getBoundingClientRect();
		const elementTop = rect.top + window.pageYOffset;

		const alignedTop =
		  align === 'center'
			? elementTop - (window.innerHeight / 2) + (rect.height / 2)
			: elementTop;

		const top = alignedTop - dockOffset;
		window.scrollTo({top: clampToTop ? Math.max(0, top) : top, behavior});
	};

	// 2 RAF → waiting layout/hydration/dock update
	let left = retries;
	const tick = () => {
		doScroll();
		if (left-- > 0) requestAnimationFrame(tick);
	};

	requestAnimationFrame(() => requestAnimationFrame(tick));
	return true;
}

/**
 * Делегиран click handler за елементи с [data-scroll-target].
 * Закача се на общ родител (напр. <ul>) и скролва до таргета при клик по линк вътре.
 *
 * @param e click event
 * @param options настройки, подавани към ScrollToTarget
 * @returns {void}
 */
export function HandleScrollClick(e, options = {}) {
	const link = e.target.closest('[data-scroll-target]');
	if (!link) {
		return;
	}

	e.preventDefault();
	ScrollToTarget(link.dataset.scrollTarget, options);
}

/**
 * Пренасочва към даден URL, като може да избира дали да е в същия таб или в нов.
 *
 * @param url
 * @param target
 * @returns {void}
 */
export function RedirectTo(url, target = '') {
	if (target) {
		window.open(url, '_blank', 'noopener');
	} else {
		window.location.href = url;
	}
}

/**
 * Load tab from tab menu
 *
 * @param tab
 * @returns {void}
 */
export function NavigateToTab(tab) {
	if (!tab) {
		return;
	}

	window.dispatchEvent(new CustomEvent('sh:navigate-tab', {detail: {id: tab}}));
}

/**
 * Redirect to hosting from homepage
 *
 * @returns {void}
 */
export function RedirectToHostingFromHomePageBanner() {
	HelperGoogleAnalytics4.TrackEvent("HomePage Events", "View Plans Button", "Homepage-left");
	window.location.href = '/web-hosting-compare-hosting-plans.php?tab=prices';
}

/**
 * Start shopiko trial order
 *
 * @param contextCart
 * @returns {void}
 */
export function StartShopikoTrial(contextCart = null) {
	if (!contextCart) {
		return;
	}

	contextCart.startShopikoTrial();
}

/**
 * Start SiteBuilder trial order
 *
 * @param contextCart
 * @param contextTaxonomy
 * @returns {void}
 */
export function StartWebnodeTrial(contextCart = null, contextTaxonomy = null) {
	if (!contextCart || !contextTaxonomy) {
		return;
	}

	const taxonomy = contextTaxonomy.getForId('webnode_01');
	taxonomy.name = 'SiteStart';

	const label = HelperGoogleAnalytics.GetAnalyticsEventLabelSimple(taxonomy);

	HelperGoogleAnalytics.TrackNonInteractionEvent(
	  'Free trial',
	  'SiteBuilder Events',
	  label
	);
	HelperGoogleAnalytics4.TrackEvent('SiteBuilder Events', 'Free trial', label);

	contextCart.startWebnodeTrial();
}

/**
 * Start SiteBuilder trial order
 *
 * @param contextCart
 * @param contextTaxonomy
 * @param serviceId
 * @param templateId
 * @returns {void}
 */
export function StartSiteBuilderTrial(contextCart = null, contextTaxonomy = null, serviceId = '', templateId = '') {
	const planNames = {
		skreat_01: 'SiteStart',
		skreat_02: 'SiteBusiness',
		skreat_03: 'SitePro',
	}
	const taxonomy = contextTaxonomy.getForId(serviceId)
	taxonomy.name = planNames[serviceId]
	const label = HelperGoogleAnalytics.GetAnalyticsEventLabelSimple(taxonomy)
	HelperGoogleAnalytics.TrackNonInteractionEvent(
	  'Free trial',
	  'SiteBuilder Events',
	  label
	)
	HelperGoogleAnalytics4.TrackEvent('SiteBuilder Events', 'Free trial', label)

	contextCart.startSiteBuilderTrial(serviceId, templateId);
}

/**
 * Before submit domain search, run analytics events
 *
 * @param domainNameFull
 * @param fromPage
 * @returns {void}
 */
export function BeforeSubmitDomainsSearch(domainNameFull, fromPage) {
	if (fromPage === 'Domains') {
		const eventData = {
			event_category: 'InCart Actions',
			event_label: 'Product Category/Domains - Checkout/Step 1 - Domains - ["' + domainNameFull + '"]',
			non_interaction: true
		};
		HelperGoogleAnalytics.TrackEvent('Domain Selector - Query Domain', eventData);
		HelperGoogleAnalytics4.TrackEvent('InCart Actions', 'Domain Selector - Query Domain', 'Product Category/Domains - Checkout/Step 1 - Domains - ["' + domainNameFull + '"]');
	} else {
		HelperGoogleAnalytics4.TrackEvent('HomePage Events', 'Find Domain Button', 'Homepage-right');
	}
}

/**
 * Cart continue
 *
 * @param contextCart
 * @returns {void}
 */
export function ActionContinue(contextCart = null) {
	if (!contextCart) {
		return;
	}

	contextCart.runAction('ActionContinue');
}

/**
 * Add service to cart
 *
 * @param contextCart
 * @param serviceId
 * @param servicePriceId
 * @param term
 * @param breadCrumbMode
 * @param getPriceId
 * @param promoCode
 * @returns {void}
 */
export function AddToCart(
  contextCart = null,
  serviceId = '',
  servicePriceId = '',
  term = null,
  breadCrumbMode = '',
  getPriceId = null,
  promoCode = ''
) {
	if (!contextCart) {
		return;
	}
	if (!servicePriceId) {
		if (!serviceId || !term || !getPriceId || typeof getPriceId !== 'function') {
			console.log('Missing price id.');
			return;
		}

		servicePriceId = getPriceId(serviceId, term);

		if (!servicePriceId) {
			console.log('Missing price id.');
			return;
		}
	}

	promoCode = typeof promoCode === 'string' ? promoCode.trim() : '';

	if (serviceId === 'plan_01' && term <= 12) {
		contextCart.addSSToCart(servicePriceId, breadCrumbMode, promoCode);
		return;
	}

	contextCart.addServiceToCart(servicePriceId, breadCrumbMode, () => ActionContinue(contextCart), promoCode);
}

/**
 * Runs an operator task action (e.g. CreateMigrationTask, CreatePartnerTask) from the operator task context.
 *
 * @param contextOperatorTask The ContextOperatorTask value
 * @param taskName Name of the task creator function to run
 * @param formData Form payload to submit
 * @param onSuccess Success callback
 * @param onError Error callback
 * @returns {void}
 */
export function SubmitOperatorTask(
  contextOperatorTask = null,
  taskName = '',
  formData = {},
  onSuccess = () => {
  },
  onError = () => {
  }
) {
	const createTask = contextOperatorTask ? contextOperatorTask[taskName] : null;
	if (typeof createTask !== 'function') {
		console.error(`SubmitOperatorTask: unknown task "${taskName}".`);
		return;
	}

	createTask(formData, onSuccess, onError);
}

/**
 * Format price value
 *
 * @param value
 * @param value2
 * @returns {number} formatted price
 */
export function FormatPrice(value, value2 = null) {
	if (typeof value === 'string') {
		value = value.replace(',', '.');
	}
	if (typeof value2 === 'string') {
		value2 = value2.replace(',', '.');
	}

	let floatVal = parseFloat(value);

	if (value2 !== null) {
		let floatVal2 = parseFloat(value2);
		floatVal = floatVal + floatVal2;
	}

	let isInteger = Number.isInteger(floatVal);

	return floatVal.toLocaleString('bg-BG', {
		minimumFractionDigits: isInteger ? 0 : 2,
		maximumFractionDigits: isInteger ? 0 : 2
	});
}
